import { useContext } from 'react';

import { AcpsCreditsClientContext, AcpsCreditsContext } from './AcpsCreditsClientProvider';

export const useAcpsCreditsClient = (): AcpsCreditsContext => {
  const context = useContext(AcpsCreditsClientContext);

  if (context === null) {
    throw new Error('useAcpsCreditsClient must be used within a AcpsCreditsClientProvider');
  }

  return context;
};
